import { toast } from "react-toastify";
import * as XLSX from "xlsx";

// api function to fetch data
export const fetchData = async (apiFunction, setData) => {
  try {
    const response = await apiFunction();
    if (response.status && response.data) {
      setData(response.data);
    } else {
      setData([]);
      console.log("warning", response.error || "No Data to Show !");
    }
  } catch (error) {
    setData([]);
    console.log("warning", error.mess || "Something went wrong!");
  }
};

// show toast
export const showToast = (type, message, position = "top-right") => {
  toast[type](message, { position: position, autoClose: 1500 });
};

// remove zeros at front
export const removeZeroFront = (num) => {
  if (!num) return "";
  return num.replace(/^[0]+/, "");
};

// payment status
export const paymentStatus = (total, paid) =>
  total && paid
    ? Number(total) > Number(paid)
      ? "Partially Paid"
      : "Fully Paid"
    : "";

// formate the text to title case
export const formatToTitleCase = (text) => {
  return text
    .replace(/-/g, " ") // Replace underscores with spaces
    .toLowerCase() // Convert to lowercase
    .split(" ") // Split into an array of words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(" "); // Join the words back into a single string
};

// formate the name
export const formateName = (str) => {
  if (!str) return "";
  str = str.replace(/[^a-zA-Z0-9 ]/g, "");
  const cleanedWord = formatToTitleCase(str.replace(/^[0-9]+/, ""));
  return cleanedWord;
};

// Custom XLSX Export Function
export const exportCustomXLSX = (headers, data, fileName) => {
  // Create a worksheet from the data
  const worksheetData = [
    headers,
    ...data.map((row) => headers.map((field) => row[field])),
  ];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Create a new workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Write the workbook as an XLSX file
  XLSX.writeFile(workbook, `${fileName}_data.xlsx`);
};

// Custom CSV Export Function
export const exportCustomCSV = (headers, data, fileName) => {
  const csvRows = [];
  csvRows.push(headers.join(","));
  data.forEach((row) => {
    const csvRow = headers
      .map((field) => {
        const value = row[field];
        if (typeof value === "string" && value.includes(",")) {
          return `"${value}"`;
        }
        return value;
      })
      .join(",");
    csvRows.push(csvRow);
  });
  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}_data.csv`;
  link.click();
};

// download sample lead data formate
export const sampleDownload = (fileURL, fileName, type) => {
  const fileUrl = fileURL;
  const link = document.createElement("a"); // Create a link and trigger download
  link.href = fileUrl;
  link.setAttribute("download", `${fileName}_data.${type}`); // Optional: Set the download attribute
  document.body.appendChild(link); // Append the link to the body
  link.click(); // Simulate a click
  document.body.removeChild(link); // Clean up
};

// trim white space in object
export const trimObjectValues = (obj) => {
  const trimmedObject = {};
  for (const key in obj) {
    typeof obj[key] === "string"
      ? (trimmedObject[key] = obj[key].trim())
      : (trimmedObject[key] = obj[key]);
  }
  return trimmedObject;
};

// date string to yyyy-mm-dd formate
export const strTODateFormate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0"); // Add 1 since months are 0-indexed
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// serial number to date foemate
function excelSerialToDateString(serial) {
  if (!isNaN(serial) && serial > 30000) { // Check if it's a serial number
      const excelEpoch = new Date(1899, 11, 30);
      const days = Math.floor(serial);
      const date = new Date(excelEpoch.getTime() + days * 24 * 60 * 60 * 1000);
      return date.toLocaleDateString("en-GB"); // Convert to "DD/MM/YYYY"
  }
  return serial; // Return original if it's already a string
}

// date to yyyy-mm-dd formate
export const dateFormate = (date) => {
  const parts = String(excelSerialToDateString(date)).split(/[-/]/);  
  const d = new Date(parts[2], parts[1] - 1, parts[0]); // YYYY, MM (0-based), DD  
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0"); // Add 1 since months are 0-indexed
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// create serial no for datas
export const getSerialNo = (rowData, index) => index.rowIndex + 1;
